var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gender@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-734.000000, -243.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(254.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Female",
    transform: "translate(447.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4776657,77.0012655 C78.4877424,77.0128494 88.0292392,69.3758367 90.4315593,58.6289723 C92.8338795,47.8821079 87.4526461,36.9080349 77.4859742,32.2287427 C67.5193023,27.5494506 55.640563,30.420071 48.9093973,39.1345686 C42.1782315,47.8490662 42.4001471,60.0699418 49.4432576,68.5342201 L43.7118329,74.2667446 L36.5920508,67.1455961 C35.7504648,66.3612476 34.439001,66.3843913 33.6256027,67.1979457 C32.8122044,68.0115001 32.7890651,69.3232155 33.5732632,70.1649631 L40.6930453,77.2861115 L33.5732632,84.4072599 C32.7890651,85.2490074 32.8122044,86.5607229 33.6256027,87.3742773 C34.439001,88.1878317 35.7504648,88.2109754 36.5920508,87.4266268 L43.7118329,80.3054784 L50.8316151,87.4266268 C51.6732011,88.2109754 52.9846649,88.1878317 53.7980632,87.3742773 C54.6114615,86.5607229 54.6346007,85.2490074 53.8504027,84.4072599 L46.7306206,77.2861115 L52.4620452,71.553587 C56.6723875,75.0767078 61.9881681,77.005277 67.4776657,77.0012655 Z M48.2542539,53.5014758 C48.2542539,42.8826413 56.8608686,34.274375 67.4776657,34.274375 C78.0944629,34.274375 86.7010775,42.8826413 86.7010775,53.5014758 C86.7010775,64.1203103 78.0944629,72.7285765 67.4776657,72.7285765 C56.8719874,72.7207218 48.2763467,64.1234316 48.2684935,53.5157181 L48.2542539,53.5014758 Z",
    id: "Gender"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderBig);
export default __webpack_public_path__ + "static/media/gender_big.1b9ccfaa755a3c6d0fcae4735bf4487c.svg";
export { ForwardRef as ReactComponent };